import { jsx as _jsx } from "react/jsx-runtime";
import { useStore } from 'react-redux';
import { setSearchString } from '../../../../../app/engagement/actions';
import styles from './styles.module.scss';
import { SearchInput } from '../../../../infra/ui/search-input';
import { useReduxSelector } from '../../../../infra/redux-bridge';
export var CampaignSearchInputRedesign = function () {
    var store = useStore();
    var initialValue = useReduxSelector('engagement.searchString');
    var setCampaignFilter = function (value) { return store.dispatch(setSearchString(value)); };
    return (_jsx("div", { className: styles['redesign-search-container'], children: _jsx("div", { className: "c-search-input", children: _jsx(SearchInput, { className: "c-search-input-component", name: "campaign-list-search-input", placeholder: "Search for campaigns", showIcon: true, setSearchTerm: setCampaignFilter, initialValue: initialValue }) }) }));
};
